<template>
  <div class="content-right">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="body-content-overlay"></div>
        <!-- Main contact area -->
        <section class="chat-app-window">
          <!-- To load Conversation -->
          <div class="start-chat-area d-none">
            <div class="mb-1 start-chat-icon">
              <i data-feather="message-square"></i>
            </div>
            <h4 class="sidebar-toggle start-chat-text">Select Contact</h4>
          </div>
          <!--/ To load Conversation -->

          <!-- Active Contact -->
          <div class="active-chat">
            <!-- Contact Header -->
            <div class="chat-navbar">
              <header class="chat-header">
                <div class="d-flex align-items-center">
                  <div @click="$emit('sidebarActiveInactive')" class="sidebar-toggle d-block d-lg-none me-1">
                    <i class="fa fa-bars"></i>
                  </div>
                  <div class="avatar avatar-border user-profile-toggle m-0 me-1">
                    <img :src="contactInfo.photo" width="42" class="border-0" :alt="contactInfo.full_name"/>
                  </div>
                  <h6 class="mb-0">
                    {{ contactInfo.full_name }}<br>
                    <small v-for="profile_item in contactInfo.profile_items">
                      {{ profile_item.value }}<br>
                    </small>
                  </h6>
                </div>
                <div class="d-flex align-items-center me-md-3 me-lg-3">
                  <div @click="openBeneficiaryStageModal(contactInfo)">
                    <h5 role="button" class="btn btn-primary">{{ beneficiaryStage ? beneficiaryStage.beneficiary_stage_name : 'Update Stage' }}</h5>
                  </div>
                  <div @click="$emit('handleEdit', contactInfo)" class="mx-1">
                    <h5 role="button" class="btn btn-dark">Profile</h5>
                  </div>
                </div>

              </header>
            </div>
            <!--/ Contact Header -->

            <!-- User Chat messages -->
            <div class="user-chats">
              <div class="chats">
                <ul class="nav nav-tabs">
                  <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :href="`#${tab.id}`"
                        :class="['nav-link', { active: activeTabId === tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                      {{ tab.title }}
                    </a>
                  </li>
                </ul>
                <component :is="activeTab" :contactDetails="contactDetails" :contactInfo="contactInfo"/>
              </div>
            </div>
            <!-- User Contact messages -->
          </div>
          <!--/ Active Contact -->
        </section>
        <!--/ Main contact area -->

        <BeneficiaryStageModal
            v-if="isBeneficiaryModalOpen"
            :contact="selectedContact"
            @getContactDetails="(id) => $emit('getContactDetails', id)"
            @close="closeBeneficiaryStageModal"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import LevelUpdateLogs from "@/views/page/company/procurement/beneficiary/register/tabs/LevelUpdateLogs.vue";
import Meeting from "@/views/page/company/procurement/beneficiary/register/tabs/Meeting.vue";
import Note from "@/views/page/company/procurement/beneficiary/register/tabs/Note.vue";
import Call from "@/views/page/company/procurement/beneficiary/register/tabs/Call.vue";
import Email from "@/views/page/company/procurement/beneficiary/register/tabs/Email.vue";
import Message from "@/views/page/company/procurement/beneficiary/register/tabs/Message.vue";
import Attachment from "@/components/molecule/company/hospital/patient/register/tabs/Attachment.vue";
import BeneficiaryStageModal from "@/views/page/company/procurement/beneficiary/beneficiary-stage/BeneficiaryStageModal.vue";
import {ref} from "vue";
import {useStore} from "vuex";

const activeTab = ref(LevelUpdateLogs)
const activeTabId = ref('level_update_log')
const props = defineProps({
  contactInfo: {
    type: Object,
    default: {
      full_name: '',
      profile_items: [],
      contact: {},
    }
  },
  contactDetails: {
    type: Array,
    default: []
  },
  beneficiaryStage: {
    type: Object,
    default: {}
  }
})

const store = useStore()
const isBeneficiaryModalOpen = ref(false)
const selectedContact = ref(null)

const tabs = [
  {id: 'level_update_log', title: 'Activity Logs', component: LevelUpdateLogs},
  {id: 'call', title: 'Call', component: Call},
  {id: 'email', title: 'Email', component: Email},
  {id: 'message', title: 'Message', component: Message},
  {id: 'meeting', title: 'Meeting', component: Meeting},
  {id: 'note', title: 'Note', component: Note},
  {id: 'attachment', title: 'Attachment', component: Attachment},
]

const setActiveTab = tab => {
  activeTab.value = tab.component;
  activeTabId.value = tab.id;
};

const openBeneficiaryStageModal = (contactInfo) => {
  selectedContact.value = contactInfo
  isBeneficiaryModalOpen.value = true
}

const closeBeneficiaryStageModal = () => {
  isBeneficiaryModalOpen.value = false
}

</script>

<style scoped>
.user-chats {
  background-image: none !important;
  overflow-y: scroll;
  height: calc(100% - 65px);
  overflow-x: hidden;
}
</style>
